import { FaInfoCircle } from 'react-icons/fa';

const Home = () => {
  return (
    <section style={styles.section}>
      <h2 style={styles.title}>About Us</h2>
     <p style={styles.description}>
      <span style={styles.highlight}>Bryzelo</span> is an innovative IT company delivering cutting-edge digital solutions for businesses of all sizes. We empower organizations with advanced technologies to achieve their goals with maximum efficiency and performance.
    </p>
    <p style={styles.description}>
      With years of experience, we have earned a reputation as a reliable partner known for quality, consistency, and customer focus. Our team works closely with each client, providing tailored solutions that solve challenges and drive growth.
    </p>
    <p style={styles.description}>
      At <span style={styles.highlight}>Bryzelo</span>, we continuously refine our strategies and embrace the latest technologies to deliver secure, effective, and future-ready IT solutions. Our core values are innovation, transparency, and a strong commitment to excellence.
    </p>
    <p style={styles.description}>
      Whether you are a startup building a solid digital foundation or an established company aiming to optimize operations, we are here to support you at every stage of your journey.
    </p>

    </section>
  );
};

const styles = {
  section: {
    backgroundColor: '#000',
    color: '#fff',
    padding: '60px 20px',
    textAlign: 'center',
  },
  title: {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    marginBottom: '20px',
  },
  description: {
    fontSize: '1.2rem',
    maxWidth: '800px',
    margin: '0 auto 20px',
    lineHeight: '1.6',
  },
  highlight: {
    color: ' #1acaff',
    fontWeight: 'bold',
  },
};

export default Home;
